/**
 * DetailSection — compact section with optional badge/count in the heading.
 * Used in the ALT B data-dense body layout.
 */
export function DetailSection({
  title,
  count,
  children,
  className,
}: {
  title: string;
  count?: number;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <section className={className} aria-label={title}>
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          {title}
          {count !== undefined && (
            <span className="ml-1.5 inline-flex items-center justify-center rounded-full bg-muted px-1.5 py-0.5 text-xs tabular-nums">
              {count}
            </span>
          )}
        </h3>
      </div>
      {children}
    </section>
  );
}
